module.exports = function (fox) {
	'use strict';
	require('../../../../common-components/popupWidget')(fox);
	require('./widget/avsYoti.es')(fox);
	require('fox-dynamic-injection!fox-template-loader!./templates/banner.tpl')(fox);
	require('./stylus/_index.styl');
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/avs-yoti/index.es.js